// extracted by mini-css-extract-plugin
export default {"box":"ExplorerBlocker_box__-U21R"};